module.exports = __webpack_public_path__ + "img/20191118160210959.52c736ef.jpg";